import React, {Component} from 'react';
import {UncontrolledTooltip} from 'reactstrap';
import {deepCopyObject} from "../../../helper/helper";
import {validateField} from "../../../common/validation";

class SGK extends Component{
	constructor(props){
		super(props);
		this.state ={error:{},sgkInfo:null};
		this.onChange 		= this.onChange.bind(this);
		this.validateField  = this.validateField.bind(this);
	}

	componentWillMount() {
		this.setState({sgkInfo:this.props.sgkInfo});
	}

	onChange(e){
		let sgkInfo = deepCopyObject(this.state.sgkInfo);
		if(e.target.name === "sgkFileNo") {
			if (!isNaN(e.target.value)) {
				sgkInfo[e.target.name]= e.target.value;
			}
		} else {
			sgkInfo[e.target.name]= e.target.value;
		}
		this.setState({sgkInfo});
		this.props.listener(sgkInfo);
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let result = validateField(rule, boundary, e.target.value);
		let error = this.state.error;
		error = Object.assign(error, {[id]: result});
		this.setState({error});
		this.props.errorListener(error);
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	componentWillReceiveProps(nextProps){
		if(this.props.error !== nextProps.error){
			this.setState({error:nextProps.error});
		}

		if (nextProps.manual) {
			this.setState({sgkInfo: nextProps.sgkInfo,error:{}});
			this.props.isManual(false);
			this.props.errorListener({});
		}
	}



	render(){
		if(!this.state.sgkInfo)
			return <div>Yükleniyor...</div>;


		let accountingCost = this.props.accountingCost;
		let render = 	(accountingCost !== "MAL_HIZMET" &&
						 accountingCost !== "ABONELIK" &&
						 accountingCost !== "DIGER");
		return (
			<div className="col-sm-12 row">
				{ render &&
					<div className="col-sm-8 row">
						<label className="col-sm-4 col-form-label" style={{whiteSpace:'nowrap'}}>Mükellef Kodu*</label>
						<div className="col-sm-8">
							<div className={"form-group" + this.validateClass("sgkMukellefKodu")}>
								<input className="form-control"
									   type="text"
									   data-vlength="1,255"
									   id="sgkMukellefKodu"
									   name="sgkMukellefKodu"
									   onBlur={(e)=>this.validateField(e)}
									   onChange={this.onChange}
									   value={this.state.sgkInfo.sgkMukellefKodu}/>
								{this.validateMessage("sgkMukellefKodu") !== "" &&
								<UncontrolledTooltip placement="right" target={"sgkMukellefKodu"} delay={0}>
									{this.validateMessage("sgkMukellefKodu")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
				}
				{render &&
					<div className="col-sm-8 row">
						<label className="col-sm-4 col-form-label" style={{whiteSpace:'nowrap'}}>Mükellef Adı* </label>
						<div className="col-sm-8">
							<div className={"form-group" + this.validateClass("sgkMukellefAdi")}>
								<input className="form-control"
									   type="text"
									   data-vlength="1,255"
									   id="sgkMukellefAdi"
									   name="sgkMukellefAdi"
									   onBlur={(e)=>this.validateField(e)}
									   onChange={this.onChange}
									   value={this.state.sgkInfo.sgkMukellefAdi}/>
								{this.validateMessage("sgkMukellefAdi") !== "" &&
								<UncontrolledTooltip placement="right" target={"sgkMukellefAdi"} delay={0}>
									{this.validateMessage("sgkMukellefAdi")}
								</UncontrolledTooltip>}
							</div>
						</div>
					</div>
				}
				<div className="col-sm-8 row">
					<label className="col-sm-4 col-form-label" style={{whiteSpace:'nowrap'}}>{(this.props.accountingCost !== "MAL_HIZMET" ? "Dosya No*" : "Harcama Referans No:")} </label>
					<div className="col-sm-8">
						<div className={"form-group" + this.validateClass("sgkFileNo")}>
							<input className="form-control"
								   type="text"
								   data-vlength={this.props.accountingCost === "ABONELIK" ? "1,255" :"0,255"}
								   id="sgkFileNo"
								   name="sgkFileNo"
								   onBlur={(e)=>this.validateField(e)}
								   onChange={this.onChange}
								   value={this.state.sgkInfo.sgkFileNo ? this.state.sgkInfo.sgkFileNo : ""}/>
							{this.validateMessage("sgkFileNo") !== "" &&
							<UncontrolledTooltip placement="right" target={"sgkFileNo"} delay={0}>
								{this.validateMessage("sgkFileNo")}
							</UncontrolledTooltip>}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default SGK;